import { Injectable } from '@angular/core';
import { AppSettings } from 'src/app.settings';

@Injectable({ providedIn: 'root' })
export class AppSettingsStore {
  private settings?: AppSettings;

  get isLoaded(): boolean {
    return !!this.settings;
  }

  set(value: AppSettings): void {
    this.settings = value;
  }

  get(): AppSettings {
    if (!this.settings) {
      throw new Error('APP_SETTINGS was requested before runtime configuration was loaded.');
    }

    return this.settings;
  }
}
